import ClearIcon from '@material-ui/icons/ClearOutlined'
import { DateTimePicker, IconButton, OsDateTimePickerVersion, styled, Tooltip, useComponentVersion } from 'opensolar-ui'
import PropTypes from 'prop-types'
import { FieldTitle, useInput, useLocale, useTranslate } from 'react-admin'
import { getDateFormat, parseDateObject, parseInputValue } from 'util/date'
import { CalendarGrey } from './DateInput'

const FullWidthDateTimePicker = styled(DateTimePicker)({
  width: '100%',
})

const DateTimeInput = ({ label, options = {}, source, resource, helperText, margin = 'dense', onBlur, onChange, onFocus, optionsTime, labelTime, validate, hideClearButton, inputVariant, variant = 'filled', disablePast = false, disabled, style = {}, fullWidth, ...rest }) => {
  const { id, input, isRequired } = useInput({
    onBlur,
    onChange,
    onFocus,
    resource,
    source,
    validate,
    ...rest,
  })
  const locale = useLocale()
  const dayjsFormat = useComponentVersion('date_picker') === OsDateTimePickerVersion.V2

  // Not sure why this isn't 'datetime' for everyone, but not to break existing UX2 behavior
  let formatVariant = dayjsFormat ? 'datetime' : undefined
  let format = getDateFormat({ locale, long: false, dayjsFormat, variant: formatVariant })

  const translate = useTranslate()
  const handleChange = (date) => {
    input.onChange(parseDateObject(date)?.toISOString() || null)
    input.onBlur()
  }

  const clearDate = () => {
    input.onChange(null)
    input.onBlur()
  }
  const value = parseInputValue(input?.value, dayjsFormat)
  return (
    <div
      id={id}
      style={{
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        width: fullWidth ? '100%' : 256,
        ...style,
      }}
    >
      <FullWidthDateTimePicker
        variant="inline"
        ampm={true}
        label={<FieldTitle label={label} source={source} resource={resource} isRequired={isRequired} />}
        value={value}
        onChange={handleChange}
        autoOk
        format={format}
        margin={margin}
        onError={(validationError) => {
          if (validationError) {
            console.log('Date time validation error', validationError)
          }
        }}
        disablePast={disablePast}
        helperText={`${translate('Timezone')}: ${Intl.DateTimeFormat().resolvedOptions().timeZone}`}
        style={{ width: '100%', marginRight: 0 }}
        disabled={disabled}
        InputProps={{
          endAdornment:
            !disabled && !hideClearButton && input.value ? (
              <Tooltip title={translate('Clear Date')} enterDelay={300}>
                <IconButton
                  disabled={disabled}
                  onClick={clearDate}
                  style={{
                    padding: 5,
                    right: 0,
                    width: 30,
                    height: 30,
                  }}
                >
                  <ClearIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <CalendarGrey />
            ),
        }}
        {...options}
      />
    </div>
  )
}

DateTimeInput.propTypes = {
  label: PropTypes.string,
  options: PropTypes.object,
  resource: PropTypes.string,
  source: PropTypes.string,
}

export default DateTimeInput
